import React, { useEffect, useState } from "react";

import CustomizeTime from "../Drawers/CustomizeTime";
import Filtericon from "../../assets/svg/filter-icon.svg";
import { servicePost } from "../../helper/api";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
// import usePagination from "../../hooks/usePagination";
import Navbar from "../../Components/Navbar/Navbar";
import DateFilter from "../Dropdown/DateFilter";
import Sidebar from "../../Components/Sidebar/Sidebar";
import ConfirmationModal from "../Modals/ConfirmationModal";
import Dropdown from "../Dropdown/Dropdown";

// Cleaner DropDown Values
const TypeDropData = [
  {
    name: "All",
  },
  {
    name: "Commercial",
  },
  {
    name: "Residential",
  },
];

// Status DropDown Data
const StatusDropdown = [
  {
    name: "All",
  },
  {
    name: "Pending",
  },
  {
    name: "Processing",
  },

  {
    name: "Completed",
  },
];

const CleanerPayment = () => {
  const [modalShow, setModalShow] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedCleaner, setSelectedCleaner] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [searchValue, setSearchValue] = useState("");

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const navigate = useNavigate();

  const handleDateChange = (selectedDate) => {
    setSelectedDate(selectedDate);

    if (selectedDate == "Customized Calender") {
      document.getElementById("customizedate").click();
      setFilterDate("");
    } else if (selectedDate == "Past 90 Days") {
      var date = new Date();
      date.setDate(date.getDate() - 90);
      setFilterDate(date);
      setFilterStartDate("");
      setFilterEndDate("");
    } else if (selectedDate == "Past 30 Days") {
      var date = new Date();
      date.setDate(date.getDate() - 30);
      setFilterDate(date);
      setFilterStartDate("");
      setFilterEndDate("");
    } else if (selectedDate == "Past 7 Days") {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      setFilterDate(date);
      setFilterStartDate("");
      setFilterEndDate("");
    } else {
      setFilterDate("");
      setFilterStartDate("");
      setFilterEndDate("");
    }
  };

  const [cleanerList, setCleanerList] = useState([
    { name: "All" }, // Predefined value
  ]);
  const [listTransaction, setListTransaction] = useState();
  const [filterDate, setFilterDate] = useState("");
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");

  console.log("listTransaction", listTransaction);

  const getAllCleanerPayments = async () => {
    try {
      const allPaymentsRes = await servicePost(
        "adminbooking/getCleanerPayData",
        {},
        notification,
        authToken
      );
      console.log("allPaymentsRes", allPaymentsRes);

      const sortedCleanerPayments = allPaymentsRes.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      setListTransaction(sortedCleanerPayments);

      // Extract contractor names from the response data
      const newCleaners = allPaymentsRes.data.map((item) => ({
        name: item.contractorName,
      }));
      // Create a Set to track unique cleaner names
      const uniqueCleanerSet = new Set(
        cleanerList.map((cleaner) => cleaner.name)
      );

      // Filter new cleaners to only add unique names
      const uniqueCleaners = [
        ...cleanerList,
        ...newCleaners.filter((newCleaner) => {
          if (!uniqueCleanerSet.has(newCleaner.name)) {
            uniqueCleanerSet.add(newCleaner.name);
            return true; // Include this new cleaner
          }
          return false; // Exclude duplicate
        }),
      ];

      // Set the updated cleaner list without duplicates
      setCleanerList(uniqueCleaners);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getAllCleanerPayments();
  }, []);

  // test*******
  const filterData = [];
  const [filterGetAllData, setFilterGetAllData] = useState();
  const reqForFilter = () => {
    listTransaction
      ?.filter((data) => {
        const transactionDate = new Date(data.fromDate);
        const startDate = filterStartDate ? new Date(filterStartDate) : null;
        const endDate = filterEndDate ? new Date(filterEndDate) : null;

        // Handle filtering for "Past 7 Days", "Past 30 Days"  "Past 90 Days"
        if (filterDate) {
          return transactionDate >= filterDate;
        }

        if (!startDate && !endDate) {
          return true; // No date range filter, keep the item
        }

        if (startDate && endDate) {
          const isSameDay = startDate.toDateString() === endDate.toDateString();
          if (isSameDay) {
            return transactionDate.toDateString() === startDate.toDateString();
          }
          return (
            (transactionDate >= startDate && transactionDate <= endDate) ||
            transactionDate.toDateString() === startDate.toDateString() ||
            transactionDate.toDateString() === endDate.toDateString()
          );
        }

        if (!startDate && endDate) {
          return transactionDate >= endDate;
        }

        if (startDate && !endDate) {
          return transactionDate <= startDate;
        }

        return false; // Default case, filter out unmatched items
      })
      .map((data) => {
        filterData.push({
          accountId: data.accountId,
          bookingId: data.bookingId,
          bookingStatus: data.bookingStatus,
          cleanerCommisionWeekly: data.cleanerCommisionWeekly,
          contractorEmail: data.contractorEmail,
          contractorName: data.contractorName,
          contractorPayoutId: data.contractorPayoutId,
          contractorid: data.contractorid,
          createdAt: data.createdAt,
          fromDate: data.fromDate,
          id: data.id,
          industry: data.industry,
          invoiceId: data.invoiceId,
          payoutStatus: data.payoutStatus,
          serviceType: data.serviceType,
          toDate: data.toDate,
          updatedAt: data.updatedAt,
        });
      });
    setFilterGetAllData(filterData);
  };
  useEffect(() => {
    reqForFilter();
  }, [
    selectedCustomer,
    selectedType,
    filterDate,
    listTransaction,
    filterStartDate,
    filterEndDate,
  ]);

  // Function to filter based on searchValue
  const filterSearchData = (data) => {
    if (!searchValue || searchValue.trim() === "") {
      return data; // No filtering
    }

    const normalizedSearchValue = searchValue.toLowerCase().trim();

    return data.filter((ele) => {
      const contractorName = ele.contractorName?.toLowerCase() || "";
      const contractorPayoutId = ele.contractorPayoutId?.toLowerCase() || ""; // Convert to string if numeric

      return (
        contractorName.includes(normalizedSearchValue) ||
        contractorPayoutId.includes(normalizedSearchValue)
      );
    });
  };

  //Filter data basis of Dropdown....
  const filterCleanerData = (data) => {
    if (!selectedCleaner || selectedCleaner == "All") {
      return data;
    }
    return data.filter((ele) => ele.contractorName === selectedCleaner);
  };

  const filterTypeData = (data) => {
    if (!selectedType || selectedType == "All") {
      return data;
    }
    return data.filter((ele) => ele.serviceType === selectedType);
  };

  const filterStatusData = (data) => {
    if (!selectedStatus || selectedStatus == "All") {
      return data;
    }
    return data.filter((ele) => ele.payoutStatus === selectedStatus);
  };

  // Apply filtering in sequence
  const filteredData = filterSearchData(
    filterCleanerData(filterStatusData(filterTypeData(filterGetAllData)))
  );

  const goToPaymentDetail = (data) => {
    navigate("/cleaner-payment-detail", {
      state: {
        data: data,
      },
    });
  };

  // const handleDropdownChange = (cleaner) => {
  //   setSelectedCleaner(cleaner);
  // };

  const handleDropdownChange = (field) => (value) => {
    if (field === "Cleaner") {
      setSelectedCleaner(value);
    }
    if (field === "Type") {
      setSelectedType(value);
    }

    if (field === "Status") {
      setSelectedStatus(value);
    }
  };

  const getStatusImage = (status) => {
    if (status === "Pending") {
      return "./images/icons/status-pending.svg";
    } else if (status === "Processing") {
      return "./images/icons/status-processing.svg";
    } else if (status === "Completed") {
      return "./images/icons/status-complete.svg";
    } else if (status === "Cancelled") {
      return "./images/icons/status-cancel.svg";
    } else {
      return <span>{status}</span>;
    }
  };

  return (
    <>
      <ConfirmationModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        type="Are you sure to change the status of this transaction"
      />
      <Navbar />
      <div
        className="offcanvas offcanvas-end offcanvas-custom"
        tabIndex="-1"
        id="customizeDatecanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5 id="offcanvasRightLabel">Customize time range</h5>

          <svg
            className="drawer-cross-icon"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            xmlns="http://www.w3.org/2000/svg"
            width="38.894"
            height="38.894"
            viewBox="0 0 38.894 38.894"
          >
            <path
              id="Path_18510"
              data-name="Path 18510"
              d="M38.894,18.763v1.367c-.03.2-.066.4-.087.595-.062.577-.087,1.16-.18,1.732a18.957,18.957,0,0,1-4.2,9.313,19.088,19.088,0,0,1-12.867,6.963c-.475.055-.95.107-1.425.161H18.763c-.589-.06-1.18-.1-1.766-.184A19.039,19.039,0,0,1,7.48,34.7,19.112,19.112,0,0,1,.16,21.555Q.08,20.881,0,20.207V18.687c.029-.173.064-.345.087-.518.115-.875.165-1.764.349-2.624A19.178,19.178,0,0,1,8.516,3.423,18.658,18.658,0,0,1,17.3.163C17.788.11,18.275.054,18.763,0h1.367c.173.028.346.065.52.083.6.062,1.212.082,1.808.181A19.116,19.116,0,0,1,32.821,5.4a19.035,19.035,0,0,1,5.913,11.935q.08.712.16,1.425m-21.765.7c-.32.306-.617.579-.9.863q-1.963,1.957-3.92,3.921A1.655,1.655,0,0,0,13.23,27.1a1.668,1.668,0,0,0,1.464-.56q2.226-2.232,4.457-4.458c.1-.1.2-.185.348-.327a3.961,3.961,0,0,0,.281.359q2.225,2.232,4.457,4.458a1.628,1.628,0,0,0,2.109.283,1.645,1.645,0,0,0,.231-2.615c-1.487-1.5-2.987-2.992-4.481-4.487-.1-.1-.186-.2-.321-.344.238-.221.465-.42.679-.633q2.057-2.051,4.108-4.109a1.655,1.655,0,1,0-2.334-2.34q-2.248,2.236-4.486,4.483c-.095.095-.2.184-.315.294-.892-.9-1.756-1.771-2.622-2.64-.724-.726-1.446-1.454-2.177-2.173a1.583,1.583,0,0,0-1.7-.431,1.6,1.6,0,0,0-1.131,1.352,1.651,1.651,0,0,0,.547,1.467c1.577,1.573,3.151,3.149,4.789,4.787"
              fill="#00A19B"
            />
          </svg>
        </div>
        <div className="offcanvas-body">
          <CustomizeTime
            setFilterStartDate={setFilterStartDate}
            setFilterEndDate={setFilterEndDate}
            filterStartDate={filterStartDate}
            filterEndDate={filterEndDate}
          />
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end offcanvas-custom"
        tabIndex="-1"
        id="filtercanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5 id="offcanvasRightLabel">Filters</h5>

          <svg
            className="drawer-cross-icon"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            xmlns="http://www.w3.org/2000/svg"
            width="38.894"
            height="38.894"
            viewBox="0 0 38.894 38.894"
          >
            <path
              id="Path_18510"
              data-name="Path 18510"
              d="M38.894,18.763v1.367c-.03.2-.066.4-.087.595-.062.577-.087,1.16-.18,1.732a18.957,18.957,0,0,1-4.2,9.313,19.088,19.088,0,0,1-12.867,6.963c-.475.055-.95.107-1.425.161H18.763c-.589-.06-1.18-.1-1.766-.184A19.039,19.039,0,0,1,7.48,34.7,19.112,19.112,0,0,1,.16,21.555Q.08,20.881,0,20.207V18.687c.029-.173.064-.345.087-.518.115-.875.165-1.764.349-2.624A19.178,19.178,0,0,1,8.516,3.423,18.658,18.658,0,0,1,17.3.163C17.788.11,18.275.054,18.763,0h1.367c.173.028.346.065.52.083.6.062,1.212.082,1.808.181A19.116,19.116,0,0,1,32.821,5.4a19.035,19.035,0,0,1,5.913,11.935q.08.712.16,1.425m-21.765.7c-.32.306-.617.579-.9.863q-1.963,1.957-3.92,3.921A1.655,1.655,0,0,0,13.23,27.1a1.668,1.668,0,0,0,1.464-.56q2.226-2.232,4.457-4.458c.1-.1.2-.185.348-.327a3.961,3.961,0,0,0,.281.359q2.225,2.232,4.457,4.458a1.628,1.628,0,0,0,2.109.283,1.645,1.645,0,0,0,.231-2.615c-1.487-1.5-2.987-2.992-4.481-4.487-.1-.1-.186-.2-.321-.344.238-.221.465-.42.679-.633q2.057-2.051,4.108-4.109a1.655,1.655,0,1,0-2.334-2.34q-2.248,2.236-4.486,4.483c-.095.095-.2.184-.315.294-.892-.9-1.756-1.771-2.622-2.64-.724-.726-1.446-1.454-2.177-2.173a1.583,1.583,0,0,0-1.7-.431,1.6,1.6,0,0,0-1.131,1.352,1.651,1.651,0,0,0,.547,1.467c1.577,1.573,3.151,3.149,4.789,4.787"
              fill="#00A19B"
            />
          </svg>
        </div>
        <div className="offcanvas-body">
          <div className="mobile-filter-drawer-wrapper">
            <div className="mobile-filter-drawer-wrap filter-select-wraper">
              <DateFilter onTypeChange={handleDateChange} />

              <Dropdown
                onTypeChange={handleDropdownChange("Cleaner")}
                label="Cleaner"
                data={cleanerList}
              />

              {/* <Dropdown
                onTypeChange={handleDropdownChange("Type")}
                label="Type"
                data={TypeDropData}
              /> */}

              <Dropdown
                onTypeChange={handleDropdownChange("Status")}
                label="Status"
                data={StatusDropdown}
              />
            </div>
          </div>
        </div>
      </div>
      <Sidebar />
      <div className="trasfer-histroy-wrapper transfer-admin-history-wrap">
        <div className="container">
          <div className="transfer-history-header transaction-header-main-wrap">
            <div className="transfer-history-title-wrap">
              <img
                className="cleaner-payment-icon"
                src="./images/icons/payment-icon.svg"
                alt="icon"
              />
              <h3> Cleaner Payment </h3>
            </div>

            <div className="account-search-main-wrap">
              <div className="search-icon">
                <img src="./images/icons/search-icon.svg" alt="icon" />
              </div>
              <input
                onChange={(e) => setSearchValue(e.target.value)}
                value={searchValue}
                type="text"
                placeholder="Search by TxId, Client, Cleaner"
              />
            </div>
          </div>

          <div className="fiter-dropdown">
            <div className="filter-select-wraper">
              <DateFilter onTypeChange={handleDateChange} />
              <Dropdown
                onTypeChange={handleDropdownChange("Cleaner")}
                label="Cleaner"
                data={cleanerList}
              />

              {/* <Dropdown
                onTypeChange={handleDropdownChange("Type")}
                label="Type"
                data={TypeDropData}
              /> */}

              <Dropdown
                onTypeChange={handleDropdownChange("Status")}
                label="Status"
                data={StatusDropdown}
              />
            </div>
          </div>

          <div className="fiter-dropdown-mobile">
            <div
              className="mobile-filter-wrap"
              data-bs-toggle="offcanvas"
              data-bs-target="#filtercanvasRight"
              aria-controls="filtercanvasRight"
            >
              <h3> Filters</h3>
              <div>
                <img src={Filtericon} alt="icon" />
              </div>
            </div>
          </div>

          <div className="tranfer-history-dropdown-wrapper table-responsive">
            <span
              id="customizedate"
              data-bs-toggle="offcanvas"
              data-bs-target="#customizeDatecanvasRight"
              aria-controls="customizeDatecanvasRight"
            ></span>

            <table id="transfer" className="table table-striped">
              <thead>
                <tr>
                  <th> Transaction Id </th>
                  <th> Cleaner </th>
                  <th> Date </th>
                  <th> Amount </th>
                  <th> Status </th>
                  <th> View</th>
                </tr>
              </thead>
              <tbody>
                {filteredData?.length > 0 ? (
                  filteredData.map((data, index) => (
                    <tr key={index}>
                      <td>#{data.contractorPayoutId}</td>
                      <td>{data.contractorName}</td>
                      <td>
                        {moment(data.fromDate).format("DD MMM")} -{" "}
                        {moment(data.toDate).format("DD MMM, YYYY")}
                      </td>
                      <td>
                        ${Number(data?.cleanerCommisionWeekly).toFixed(2)}
                      </td>
                      <td>
                        <div className="table-status-icon1">
                          <img
                            src={getStatusImage(data.payoutStatus)}
                            alt="icon"
                          />
                        </div>
                      </td>

                      <td>
                        <img
                          className="table-view-icon"
                          onClick={() => goToPaymentDetail(data)}
                          style={{ cursor: "pointer" }}
                          src="./images/icons/view-icon.svg"
                          alt="icon"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CleanerPayment;
